import styled from 'styled-components'
import { Button as ButtonComponent } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const TitleWrapper = styled.div`
  margin: 24px 0;
  text-align: center;
`

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
`

export const Title = styled.div`
  font-size: 12px;
  color: ${myPalette.aliceBlue.main};
`

export const Balance = styled.div`
  font-size: 32px;
  color: ${myPalette.aliceBlue.main};
  font-weight: 700;
`

export const Currency = styled.span`
  font-size: 24px;
  color: ${myPalette.aliceBlue.main};
  font-weight: 700;
`

export const Button = styled(ButtonComponent)`
  height: 44px;
`
